import { BusMessage, UID_BYTES_PER_ELEMENT, MessageFactory } from "flavr-common";
/**
 * Reports that a slider value changed.
 */
export class SliderValueChangeMessage extends BusMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT + // uid
            Float32Array.BYTES_PER_ELEMENT); // value
    }
    constructor(uid, value) {
        super();
        this.uid = uid;
        this.value = value;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.value = stream.float32(this.value);
    }
    static is(msg) {
        return msg.type === SliderValueChangeMessage.typestatic;
    }
}
SliderValueChangeMessage.typestatic = "SliderValueChangeMessage";
SliderValueChangeMessage.subjectstatic = "interaction";
MessageFactory.register(SliderValueChangeMessage);
/**
 * Reports that slider interaction was released.
 */
export class SliderReleaseMessage extends BusMessage {
    get byteLength() {
        return UID_BYTES_PER_ELEMENT; // uid
    }
    constructor(uid) {
        super();
        this.uid = uid;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
    }
    static is(msg) {
        return msg.type === SliderReleaseMessage.typestatic;
    }
}
SliderReleaseMessage.typestatic = "SliderReleaseMessage";
SliderReleaseMessage.subjectstatic = "interaction";
MessageFactory.register(SliderReleaseMessage);
